/** 帳號審核狀態 */
export enum AccountStatus {
  /** 審核完成 */
  APPROVED = 'approved',
  /** 營管處主管審核不通過 */
  MANAGER_UNAPPROVED = 'managerUnapproved',
  /** 員工權限審核不通過 */
  MANAGER_UNAPPROVED_EMPLOYEE = 'managerUnapprovedEmployee',
  /** 待審核 */
  PENDING = 'pending',
  /** 員工權限待審核 */
  PENDING_EMPLOYEE = 'pendingEmployee',
  /** 業務主管審核通過 */
  SUPERVISOR_APPROVED = 'supervisorApproved',
  /** 業務主管審核不通過 */
  SUPERVISOR_UNAPPROVED = 'supervisorUnapproved'
}
